export default __webpack_public_path__ + "static/media/profileImg1.2fe106ca.png";